var after = function after(delay, v) {
  return new Promise(function (res) {
    setTimeout(function () {
      res(v);
    }, delay);
  });
};

var curry2 = function curry2(fn) {
  function curried(a, b) {
    switch (arguments.length) {
      case 1:
        return function (b) {
          return fn(a, b);
        };

      case 2:
      default:
        return fn(a, b);
    }
  }

  return curried;
};
var curry3 = function curry3(fn) {
  function curried(a, b, c) {
    switch (arguments.length) {
      case 1:
      case 2:
        return curry2(function (b, c) {
          return fn(a, b, c);
        });

      case 3:
      default:
        return fn(a, b, c);
    }
  }

  return curried;
};

/* eslint-disable max-len */

var bichain = function bichain(happy, sad, p) {
  return p.then(happy).catch(sad);
};

var bichain$1 = curry3(bichain);

/* eslint-disable max-len */
var bimap = curry3(function (happy, sad, p) {
  return p.then(happy, function (err) {
    return Promise.reject(sad(err));
  });
});

var mapRej = curry2(function (fn, p) {
  return p.catch(fn);
});

var delay = curry2(function (delay, p) {
  return p.then(function (t) {
    return after(delay, t);
  });
});

var then = curry2(function (fn, p) {
  return p.then(fn);
});

var mapRej$1 = curry2(function (fn, p) {
  return p.catch(function (err) {
    return Promise.reject(fn(err));
  });
});

var never = function never() {
  return new Promise(function () {// never resolve
  });
};

var resolve = function resolve(value) {
  return Promise.resolve(value);
};

var reject = function reject(err) {
  return Promise.reject(err);
};

var rejectAfter = function rejectAfter(delay, v) {
  return new Promise(function (res, rej) {
    setTimeout(function () {
      rej(v);
    }, delay);
  });
};

var swap = function swap(p) {
  return p.then(function (t) {
    return Promise.reject(t);
  }, function (e) {
    return e;
  });
};

export { after, bichain$1 as bichain, bimap, then as chain, mapRej as chainRej, delay, then as map, mapRej$1 as mapRej, never, resolve as of, reject, rejectAfter, resolve, swap, then };
